import * as React from 'react';
import { MouseEvent } from 'react';
import { connect } from 'react-redux';
import { productInfoDeferred } from '../actions/Actions';
import { IProductInfo, IReferer, IState } from '../CustomTypes';
import { doSpidLoginLinkWithRedirectToStart } from '../fastflowUtils';
import { svgEmail } from '../icons';
import FooterSameLoginAsOthers from '../layout-components/FooterSameLoginAsOthers';
import { sccPulseTrackPageView } from '../PulseUtils';
import './WaitForEmail.scss';

export interface IWaitForEmailPageParamProps {
  productInfo: IProductInfo;
  referer: IReferer;
  emailSentTo: string;
  userCreated: string;
  hasPhone: string;
  hasPaymentMethods: string;
}

export class WaitForEmail extends React.Component<
  IWaitForEmailPageParamProps,
  {}
> {
  constructor(props: IWaitForEmailPageParamProps) {
    super(props);
    this.userCreated = this.userCreated.bind(this);
    this.loginLinkSent = this.loginLinkSent.bind(this);
  }

  public componentDidMount() {
    productInfoDeferred.promise.then(product => {
      const { userCreated } = this.props;
      const eventName = 'Sent email';
      const userStatus =
        userCreated && userCreated === 'true' ? 'new' : 'existing';
      sccPulseTrackPageView(product, {}, eventName, { userStatus });
    });
  }

  public render() {
    const userCreated =
      this.props.userCreated && this.props.userCreated === 'true';
    return (
      <div className="waitforemail">
        <div className="container">
          <h1>{svgEmail()}</h1>
          <div className="row">
            <div className="col-xs-12">
              {userCreated && this.userCreated()}
              {!userCreated && this.loginLinkSent()}
            </div>
          </div>
        </div>
        <FooterSameLoginAsOthers />
      </div>
    );
  }

  private userCreated() {
    const { emailSentTo } = this.props;
    return (
      <div>
        <h1>
          Vi har opprettet en ny bruker til deg og sendt e-posten til{' '}
          <span className="email">{emailSentTo}</span>
        </h1>
        <br />
        <h4>
          Klikk på knappen i e-posten for å logge inn og fortsette bestillingen.
        </h4>
      </div>
    );
  }

  private loginLinkSent() {
    const { emailSentTo } = this.props;
    return (
      <div>
        <h1>
          Vi har sendt deg en e-post til{' '}
          <span className="email">{emailSentTo}</span>
        </h1>
        <h4>
          Klikk på lenken i e-posten for å logge inn og fullføre bestillingen.
        </h4>
        <div className="text">
          Ikke tilgang til e-post?<br />
          <a href="" onClick={this.login}>
            Klikk her for å logge inn i SPiD
          </a>
        </div>
      </div>
    );
  }

  private login = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const { owningClient, productId, spidTeaser } = this.props.productInfo;
    doSpidLoginLinkWithRedirectToStart(
      owningClient,
      productId,
      this.props.emailSentTo,
      spidTeaser
    );
  };
}

export default connect(
  (state: IState) =>
    ({
      emailSentTo: state.router.location.query.emailSentTo,
      hasPaymentMethods: state.router.location.query.hasPaymentMethods,
      hasPhone: state.router.location.query.hasPhone,
      productInfo: state.productInfo,
      referer: state.referer,
      userCreated: state.router.location.query.userCreated
    } as IWaitForEmailPageParamProps)
)(WaitForEmail);



// WEBPACK FOOTER //
// ./src/page-components/WaitForEmail.tsx